import React, { useState } from "react";
import Footer from "../../../components/MainComponents/Footer";
import {
  bannerTestinomialDetailImage,
  bannerTestinomialImage,
  mainTitle,
} from "../../../config";
import MainBanner from "../../../components/MainComponents/MainBanner";
import ShareYourStorySection from "../../../components/TestinomialsComponents/ShareYourStorySection";
import Header from "../../../components/MainComponents/Header";

const ShareYourStory = () => {


  return (
    <div >
       <Header />
      <ShareYourStorySection/>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ShareYourStory;
